import { connect } from 'react-redux'
import {
	hideSignIn,
	showSignIn,
	signInAnonymously,
	signInWithFacebook,
	signInWithGoogle,
	signOut,
} from '../../redux/actions/auth'
import Login from './Login'

const mapStateToProps = (state) => ({
	app: state.app,
	user: state.user,
})

const mapDispatchToProps = (dispatch) => ({
	hide() {
		dispatch(hideSignIn())
	},
	show() {
		dispatch(showSignIn())
	},
	signInAnonymously() {
		dispatch(signInAnonymously())
		dispatch(hideSignIn())
	},
	signInWithFacebook() {
		dispatch(signInWithFacebook())
		dispatch(hideSignIn())
	},
	signInWithGoogle() {
		dispatch(signInWithGoogle())
		dispatch(hideSignIn())
	},
	signOut() {
		dispatch(signOut())
	},
})

const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login)

export default Container



// WEBPACK FOOTER //
// ./src/components/Login/Container.jsx